// Walker-driven selectors. The walker is the authoritative source
// for all filter rules — there are no parallel imperative paths
// left to compare against.

import type { Todo } from '../../infra/types/domain';
import type { ElkaRule, RuleSet } from './sync';
import { buildTodoContext, evalFilter, type HostFrame } from './walker';

// runFilterRule walks a FilterRule's predicate over a list of
// todos and returns those that match. Returns [] if the rule
// isn't a FilterRule or isn't in the set.
export function runFilterRule(
  rules: RuleSet,
  ruleID: string,
  todos: Todo[],
  host: HostFrame,
): Todo[] {
  const rule = rules.get(ruleID);
  if (!rule || !rule.filter || !rule.filter.predicate) return [];
  return todos.filter((t) => evalFilter(rule.filter!.predicate, buildTodoContext(t, host)));
}

// hasRule is a small convenience for code that conditionally
// switches between imperative and walker (e.g., when the client
// hasn't yet received the rule on first /sync/pull).
export function hasRule(rules: RuleSet, ruleID: string): boolean {
  return rules.has(ruleID);
}

export type { ElkaRule, RuleSet };
